import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import { BRAND_NAME, BRAND_TAGLINE, contact, navItems, whatsappUrl } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-forest-deep pt-20 text-ivory sm:pt-24" data-id="element-86" data-mp="32o48c2sn9u2u">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-87" data-mp="32m1d94cmxar9">
        <div className="grid gap-14 lg:grid-cols-3" data-id="element-88" data-mp="36pz9n7aks7gm">
          <div data-id="element-89" data-mp="3ueijvsd6qubc">
            <p className="font-serif text-2xl tracking-[0.18em]" data-id="element-90" data-mp="3ues8bbil0tex">{BRAND_NAME}</p>
            <p className="mt-4 font-serif text-xl italic text-gold-soft" data-id="element-91" data-mp="3991alritibr">
              {BRAND_TAGLINE}
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-92" data-mp="3ldkdx4j6scq4">
            <p className="text-[11px] font-semibold uppercase tracking-wider-xl text-ivory/45" data-id="element-93" data-mp="3lgonkhff80o6">
              Explore
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3.5" data-id="element-94" data-mp="29yxehh44xsnx">
              {navItems.map(item => <li key={item.label} data-id="element-95" data-mp="2ezbau1wdje64">
                  <a href={item.href} className="text-[15px] text-ivory/70 transition-colors duration-300 hover:text-gold-soft" data-id="element-96" data-mp="2ew6yuico3e4w">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-97" data-mp="3v5dgcqo0r6sf">
            <p className="text-[11px] font-semibold uppercase tracking-wider-xl text-ivory/45" data-id="element-98" data-mp="3q8wrfu8zwoea">
              Contact
            </p>
            <ul className="mt-6 space-y-3.5 text-[15px] text-ivory/70" data-id="element-99" data-mp="81yyongdi663">
              <li data-id="element-100" data-mp="34gvldp1el60">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft" data-id="element-101" data-mp="32w2lsidfaa9">
                  <MessageCircle className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-102" data-mp="qthxsj7a102u" />
                  {contact.whatsapp}
                </a>
              </li>
              <li data-id="element-103" data-mp="mthjcyk6govs">
                <a href={`mailto:${contact.email}`} className="flex items-center gap-3 transition-colors duration-300 hover:text-gold-soft" data-id="element-104" data-mp="mptq80ina4hl">
                  <Mail className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-105" data-mp="yuhb2p7xsf8n" />
                  {contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-ivory/12 py-8 text-[12px] text-ivory/40" data-id="element-106" data-mp="18lbuzmxpn2qx">
          <p className="pb-14 sm:pb-0" data-id="element-107" data-mp="1cl2t6bpkgl5h">© 2026 {BRAND_NAME}</p>
        </div>
      </div>
    </footer>;
}